export const PLAN_ROLES = [
  { value: "driver", label: "Driver" },
  { value: "owner", label: "Owner Operator" },
  { value: "carrier", label: "Carrier / Fleet" },
  { value: "broker", label: "Broker" },
];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
  "VA", "WA", "WV", "WI", "WY", "DC",
];

export const SERVICE_RADIUS_OPTIONS = [100, 250, 500, 600, 1000];
export const CDL_CLASSES = ["A", "B", "C", "None / Not applicable"];
export const TRAILER_TYPES = ["Dry Van", "Reefer", "Flatbed", "Step Deck", "Lowboy", "Tanker"];
export const ENDORSEMENTS = ["Hazmat", "Tanker", "Doubles/Triples", "Passenger", "School Bus"];
export const FREIGHT_TYPES = ["Dry Van", "Reefer", "Flatbed", "Step Deck", "Lowboy", "Tanker", "Hazmat", "LTL", "Expedited"];
export const MONTHLY_LOADS_OPTIONS = ["1-10", "11-50", "51-200", "201-500", "500+"];
export const DRIVER_NETWORK_SIZE_OPTIONS = ["0 (new brokerage)", "1-10", "11-50", "51-200", "200+"];

export const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const INITIAL_AUTH_FORM = {
  name: "", email: "", password: "", role: "driver",
  city: "", state: "", phone: "", serviceRadius: "250",
  cdlClass: "A", cdlNumber: "", experienceYears: "", trailerTypes: [], endorsements: [],
  companyName: "", dotNumber: "", mcNumber: "", fleetSize: "",
  dba: "", businessAddress: "", website: "", operatingAreas: "", freightTypes: [],
  estimatedMonthlyLoads: MONTHLY_LOADS_OPTIONS[0], estimatedDriverNetwork: DRIVER_NETWORK_SIZE_OPTIONS[0], apContact: "",
  ageConfirmed: false,
};
